import { useQuery } from '@tanstack/react-query';
import { appelApi } from './api';

export interface TachePedagogique {
  id: string;
  titre: string;
  sousTitre: string;
  statut: string;
  ton: 'danger' | 'warning' | 'info' | 'success';
  page: string;
  site: string;
}

export interface DonneesPedagogique {
  compteurs: {
    apprenants: number;
    formations: number;
    formateurs: number;
    integrationsImminentes: number;
    /** Préavis de l'intégration imminente, réglé par la direction (TF-435). */
    preavisIntegrationJours: number;
    absencesDuJour: number;
    seuilsDepasses: number;
    fichesAValider: number;
    attestationsADelivrer: number;
  };
  taches: TachePedagogique[];
}

/** Tableau de bord du pôle pédagogique : compteurs et tâches du jour (CDC §6.1). */
export function useDashboardPedagogique(site: string) {
  const parametres = site && site !== 'TOUS' ? `?site=${encodeURIComponent(site)}` : '';
  return useQuery({
    queryKey: ['dashboard-pedagogique', parametres],
    queryFn: () => appelApi<DonneesPedagogique>(`/dashboard/pedagogique${parametres}`),
  });
}
